export function formatBrazilianCurrency(value){
    // OK | SEM PONTO E SEM VIRGULA
    if (!value.includes('.') && !value.includes(',')) {
        return parseInt(`${value}`)+ ",00"
    }
    // OK | SOMENTE COM PONTO | NAO OCORRE
    if (value.includes('.') && !value.includes(',')) {
        return `${value},00`
    }
    // COM PONTO E COM VIRGULA
    if (value.includes('.') && value.includes(',')){
        let newValue = value
        if (newValue.split(",")[1].length<2){
            newValue += "0"
        }
        return newValue
    }
    // SOMENTE COM VIRGULA
    if (!value.includes('.') && value.includes(',')){
        let newValue = value
        if (newValue.split(",")[1].length<2){
            newValue += "0"
        }
        return parseInt(newValue) + ",00"
    }
}
